export enum LoginEvent {
  LOGIN = 'LOGIN',
  NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  FORGOT_PASSWORD_SUBMIT = 'FORGOT_PASSWORD_SUBMIT',
  REGISTER = 'REGISTER'
}
